import React, { useState, useEffect } from 'react';
import ProfitCalculator from './components/ProfitCalculator';
import AutoImport from './components/AutoImport';
import LoginPage from './components/LoginPage';
import apiService from './services/apiService';

function App() {
  const [authState, setAuthState] = useState('checking'); // 'checking' | 'authenticated' | 'unauthenticated'
  const [activeTab, setActiveTab] = useState('manual');   // 'manual' | 'auto'

  useEffect(() => {
    checkAuth();
    apiService.onUnauthorized = () => setAuthState('unauthenticated');
    return () => { apiService.onUnauthorized = null; };
  }, []);

  const checkAuth = async () => {
    try {
      const response = await fetch('/api/auth/status');
      const data = await response.json();
      setAuthState(data.authenticated ? 'authenticated' : 'unauthenticated');
    } catch {
      setAuthState('unauthenticated');
    }
  };

  const handleLogin = () => setAuthState('authenticated');

  const handleLogout = async () => {
    try { await fetch('/api/auth/logout', { method: 'POST' }); } catch { /* ignore */ }
    setAuthState('unauthenticated');
  };

  if (authState === 'checking') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-500">Chargement…</div>
      </div>
    );
  }

  if (authState === 'unauthenticated') {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between h-16">
            {/* Titre + onglets */}
            <div className="flex items-center gap-8">
              <h1 className="text-xl font-bold text-gray-800 whitespace-nowrap">
                Amazon Profit Analyzer
              </h1>
              <div className="flex gap-1">
                <TabButton
                  active={activeTab === 'manual'}
                  onClick={() => setActiveTab('manual')}
                >
                  📁 Import manuel
                </TabButton>
                <TabButton
                  active={activeTab === 'auto'}
                  onClick={() => setActiveTab('auto')}
                >
                  📡 Import automatique
                </TabButton>
              </div>
            </div>

            {/* Déconnexion */}
            <div className="flex items-center">
              <button
                onClick={handleLogout}
                className="text-sm text-gray-500 hover:text-gray-800 transition-colors"
              >
                Déconnexion
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main className="py-8">
        {activeTab === 'manual' && <ProfitCalculator />}
        {activeTab === 'auto'   && <AutoImport />}
      </main>
    </div>
  );
}

function TabButton({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${
        active
          ? 'bg-blue-600 text-white'
          : 'text-gray-600 hover:bg-gray-100'
      }`}
    >
      {children}
    </button>
  );
}

export default App;
